import { render } from "./IndexNew.vue?vue&type=template&id=93254866"
import script from "./IndexNew.vue?vue&type=script&lang=js"
export * from "./IndexNew.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__